'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateOpenFromUntil = exports.openUntil = exports.openFrom = undefined;
var _date = require('@marmalade/date');
var _constants = require('./constants');
var _utilities = require('./utilities');
var openFrom = exports.openFrom = function openFrom() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var nextOpen = (0, _utilities.findNextOpenDay)(date);
  var openingTime = void 0;
  if (nextOpen === 'today') {
    openingTime = _constants.openingHours[(0, _date.getNamedDay)(date.getDay()).toLowerCase()].open;
  } else if (nextOpen === 'tomorrow') {
    openingTime = _constants.openingHours[(0, _date.getNamedDay)(date.getDay() < 6 ? date.getDay() + 1 : 0).toLowerCase()].open;
  } else {
    openingTime = _constants.openingHours[nextOpen.toLowerCase()].open;
  }
  var _getHoursMinutes = (0, _utilities.getHoursMinutes)(openingTime),
    hours = _getHoursMinutes.hours,
    minutes = _getHoursMinutes.minutes;
  return 'Open ' + nextOpen + ' from ' + (0, _date.formatTime)(hours, minutes, true);
};
var openUntil = exports.openUntil = function openUntil() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var today = (0, _date.getNamedDay)(date.getDay()).toLowerCase();
  if (_constants.openingHours[today] === 'closed') {
    return undefined;
  }
  var _getHoursMinutes2 = (0, _utilities.getHoursMinutes)(_constants.openingHours[today].close),
    hours = _getHoursMinutes2.hours,
    minutes = _getHoursMinutes2.minutes;
  return 'Open today until ' + (0, _date.formatTime)(hours, minutes, true);
};
var generateOpenFromUntil = exports.generateOpenFromUntil = function generateOpenFromUntil() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return (0, _utilities.isOpen)(date) ? openUntil(date) : openFrom(date);
};